<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    :rightSticky="true"
    class="cus-bg-dialog"
    style="top:0;right:0;left:auto"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text px-6 mr-5" primary-title>
        <v-btn
          disabled
          class="mb-1 mr-1 proc-button-style proc-group drag-drawflow"
          x-small
          height="30"
          width="30"
          color="proc darken-1"
        >
          <icon-svg :size="procIconSize" iconName="proc-group" />
        </v-btn>
        <font class="text-xl font-bold leading-snug textcolor5--text">
          Workflow Group
        </font>
        <v-spacer></v-spacer>
        <v-btn class="btn btn-close rounded-xl" :disabled="!$auth.manage" @click="closeComDialog">{{
          $t('btn.common.close')
        }}</v-btn>
      </v-card-title>
    </template>
    <v-form ref="form" lazy-validation class="px-6 mt-5" style="height: 807px; overflow: auto">
      <v-row class="mt-0">
        <v-col cols="12" md="12" class="px-3 py-0">
          <v-label class="pt-2">Group Name</v-label>
          <v-autocomplete
            v-model="comId"
            :items="workflowGroupList"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            item-value="id"
            item-text="procNm"
            autofocus
            solo
            @change="changeComponentData()"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" v-if="!formData.id">
          <a class="link-file-text expand-collapse-text">Open Details</a>
        </v-col>
        <v-col cols="12" v-else>
          <a class="link-file-text expand-collapse-text" @click="openWorkflowGroupView()"
            >Open Details</a
          >
        </v-col>
      </v-row>
    </v-form>
    <discardChange
      ref="confirmDialog"
      detail="Discard Changes?"
      :showCancel="true"
      color="information"
      size="max"
      title="confirmDialog"
      @select-confirm="removeDialog()"
    ></discardChange>
  </dialog-drag>
</template>

<script>
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import discardChange from '@/vue-dlb/components/DiscardChange.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    manage: {
      default: false,
    },
  },
  components: {
    // dialogWindow,
    DialogDrag,
    discardChange,
    IconSvg,
  },
  data() {
    return {
      procIconSize: 16,
      isHistory: false,
      comId: '',
      nodeId: '',
      comTp: 'GRP',
      formData: {
        id: '',
        procNm: '',
      },
      loadFormData: {},
    };
  },
  created() {
    this.initialize();
    EventBus.$on('check-right-layer-change', this.closeComDialog);
  },
  methods: {
    changeComponentData() {
      this.changeWorkflowGroup(this.comId);
    },
    openWorkflowGroupView() {
      EventBus.$emit('open-workflow-group-component', this.formData);
    },
    initialize() {
      this.nodeId = this.options.item.data.nodeId;
      this.comTp = this.options.item.data.comTp;
      if (this.options.item.isHistory) this.isHistory = this.options.item.isHistory;
      this.changeWorkflowGroup(this.options.item.data.comId);
    },
    changeWorkflowGroup(id) {
      if (this.$refs.form) this.$refs.form.resetValidation();
      let index = this.workflowGroupList.findIndex((e) => e.id == id);
      if (index > -1 && (this.manage || this.isHistory)) {
        this.formData = Object.assign({}, this.workflowGroupList[index]);
        this.loadFormData = Object.assign({}, this.workflowGroupList[index]);
        this.comId = Object.assign({}, this.workflowGroupList[index]);
        EventBus.$emit('change-component-data', id, this.nodeId);
      } else {
        this.formData = {
          id: '',
          procNm: '',
        };
        EventBus.$emit('change-component-data', '', this.nodeId);
      }
    },
    closeComDialog() {
      this.removeDialog();
    },

    checkDataChange() {
      let editedData = getEditData(this.formData, this.loadFormData);
      if (Object.keys(editedData).length !== 0) {
        this.$refs.confirmDialog.dialog = true;
      } else {
        this.removeDialog();
      }
    },
    removeDialog() {
      this.closeDialog(this.id);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  computed: {
    workflowGroupList() {
      return this.$store.getters.workflowGroupSelectBoxList;
    },
  },
};
</script>

<style></style>
